<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        class="filter-item"
        v-model="listQuery.school_id"
        placeholder="请选择学校"
      >
        <el-option
          v-for="item in schools"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="listQuery.student_name"
        placeholder="请输入学生姓名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-date-picker
        v-model="listQuery.school_year"
        type="year"
        class="filter-item"
        value-format="yyyy"
        placeholder="选择学年"
      >
      </el-date-picker>
      <el-input
        v-model="listQuery.grade_name"
        placeholder="请输入年级"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.major_name"
        placeholder="请输入专业"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.class_name"
        placeholder="请输入班级"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-date-picker
        v-model="Timedate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        class="filter-item"
      >
      </el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <!-- <div class="filter-container">
      <span>学校:{{ data.school.name }}</span>
      <span style="margin-left: 15px">教室:{{ data.name }}</span>
    </div> -->

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="95" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.classes.college.school.name }}</template
        >
      </el-table-column>
      <el-table-column label="学生姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.student.name }}</template
        >
      </el-table-column>
      <el-table-column label="电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.student.phone }}</template
        >
      </el-table-column>
      <!-- <el-table-column label="性别" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.classes.college.name }}
        </template>
      </el-table-column> -->
      <el-table-column label="学年" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            scope.row.class_student.classes
              ? scope.row.class_student.classes.school_year
              : ""
          }}
          ~
          {{
            scope.row.class_student.classes
              ? scope.row.class_student.classes.school_year - 0 + 1
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column label="年级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.classes.grade.name }}
        </template>
      </el-table-column>
      <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.classes.major.name }}
        </template>
      </el-table-column>
      <el-table-column label="班级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class_student.classes.name }}
        </template>
      </el-table-column>
      <el-table-column label="第几次扫码上机" min-width="110" align="center">
        <template slot-scope="scope"> {{ scope.row.study_index }}</template>
      </el-table-column>
      <el-table-column label="上机时间/下机时间" min-width="220" align="center">
        <template slot-scope="scope">
          <el-tag type="success" style="margin-bottom: 10px">
            上机:{{ scope.row.start_at }}
          </el-tag>
          <el-tag type="danger" v-if="scope.row.end_at">
            下机:{{ scope.row.end_at }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="课室" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.classroom.name }}
        </template>
      </el-table-column>
      <el-table-column label="上机时长" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.duration <= 60">
            {{ scope.row.duration }}秒
          </span>
          <span v-else>
            {{ scope.row.hous }}小时 {{ scope.row.minute }}分
            {{ scope.row.second }}秒
          </span>
        </template>
      </el-table-column>
      <el-table-column label="剩余时长" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.total_surplus_duration - 0 <= 60">
            {{ scope.row.total_surplus_duration }}秒
          </span>
          <span v-else>
            {{ scope.row.total_hous }}小时 {{ scope.row.total_minute }}分钟
            {{ scope.row.total_second }}秒
          </span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        id: "",
        school_id: "",
        classroom_id: "",
        student_name: "",
        school_year: "",
        grade_name: "",
        major_name: "",
        class_name: "",
      },
      textMap: { update: "修改", create: "新增" },
      dialogFormVisible: false,
      dialogStatus: "",
      btnLoading: false,
      form: {
        id: "",
        class_id: "",
        student_id: "",
      },
      yulanData: [],
      schools: [],
      Timedate: null,
    };
  },
  created() {
    this.getList();
    this.getSchoolList();
  },
  watch: {
    Timedate(newValue, oldValue) {
      console.log(newValue, oldValue);
      if (!newValue) {
        this.listQuery.start_at = null;
        this.listQuery.end_at = null;
      } else {
        this.listQuery.start_at = newValue[0]+' 00:00:00';
        this.listQuery.end_at = newValue[1]+' 23:59:59';
      }
    },
  },
  methods: {
    //  获取学校列表
    getSchoolList() {
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: { limit: 9999999 },
      }).then((response) => {
        this.schools = response.data.data;
      });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/classroom/classLog",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.list.forEach((item) => {
          if (item.duration > 60) {
            // console.log(item.duration % 60);
            item.hous =
              Math.floor(item.duration / 3600) < 10
                ? "0" + Math.floor(item.duration / 3600)
                : Math.floor(item.duration / 3600);
            item.minute =
              Math.floor((item.duration / 60) % 60) < 10
                ? "0" + Math.floor((item.duration / 60) % 60)
                : Math.floor((item.duration / 60) % 60);
            item.second =
              Math.floor(item.duration % 60) < 10
                ? "0" + Math.floor(item.duration % 60)
                : Math.floor(item.duration % 60);
            console.log(item, "================");
          }
          if (item.total_surplus_duration - 0 > 60) {
            item.total_hous =
              Math.floor(item.total_surplus_duration / 3600) < 10
                ? "0" + Math.floor(item.total_surplus_duration / 3600)
                : Math.floor(item.total_surplus_duration / 3600);
            item.total_minute =
              Math.floor((item.total_surplus_duration / 60) % 60) < 10
                ? "0" + Math.floor((item.total_surplus_duration / 60) % 60)
                : Math.floor((item.total_surplus_duration / 60) % 60);
            item.total_second =
              Math.floor(item.total_surplus_duration % 60) < 10
                ? "0" + Math.floor(item.total_surplus_duration % 60)
                : Math.floor(item.total_surplus_duration % 60);
          }
        });
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  display: flex;
}
</style>
